import React from 'react';
import { motion } from 'framer-motion';
interface HeaderStageProps {
  /** Cover art bloomed behind the header, if the set has any. */
  artwork?: string;
}

/**
 * Premium header light for detail pages: the set's own artwork bloomed and
 * blurred behind the title, crossed by a slow accent sweep and finished with
 * grain so the panel reads as lit rather than filled.
 */
export function HeaderStage({
  artwork
}: HeaderStageProps) {
  return <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 -top-8 z-0 h-[17rem] overflow-hidden" data-id="element-52" data-mp="1xabc8ht0gh7d">
      {artwork && <motion.div key={artwork} initial={{
      opacity: 0,
      scale: 1.12
    }} animate={{
      opacity: 0.38,
      scale: 1
    }} transition={{
      duration: 0.5,
      ease: [0.23, 1, 0.32, 1]
    }} className="absolute inset-0 bg-cover bg-center blur-[64px] saturate-150" style={{
      backgroundImage: `url(${artwork})`
    }} data-id="element-53" data-mp="269g9lksu64hy" />}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.4,
      ease: [0.23, 1, 0.32, 1]
    }} className="absolute -left-24 -top-32 h-96 w-96 rounded-full blur-[110px]" style={{
      background: 'radial-gradient(circle, rgb(var(--secondary) / 0.55) 0%, rgb(var(--secondary) / 0) 70%)'
    }} data-id="element-54" data-mp="3mpj8w6eq4zml" />
      <div className="absolute -right-20 -top-24 h-80 w-80 rounded-full blur-[120px]" style={{
      background: 'radial-gradient(circle, rgb(var(--accent) / 0.4) 0%, rgb(var(--accent) / 0) 70%)'
    }} data-id="element-55" data-mp="106qetb629zt8" />
      <div className="animate-sweep absolute inset-y-0 left-0 w-1/3 opacity-0 blur-2xl" style={{
      background: 'linear-gradient(100deg, rgb(var(--accent) / 0) 0%, rgb(var(--accent-soft) / 0.22) 50%, rgb(var(--accent) / 0) 100%)'
    }} data-id="element-56" data-mp="qgfa3mejzmla" />
      <div className="absolute inset-0" style={{
      background: 'linear-gradient(to bottom, rgb(var(--surface-base) / 0.35) 0%, rgb(var(--surface-base) / 0.8) 60%, rgb(var(--surface-base)) 100%)'
    }} data-id="element-57" data-mp="ch5w8tdtl4kh" />
      <div className="grain-layer absolute inset-0 opacity-[0.06] mix-blend-soft-light" data-id="element-58" data-mp="2ule0jsavq5d" />
    </div>;
}